import { useQuery } from 'libs/query'
import { useParams } from 'libs/router'
import { useAxiosPrivate } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { HistoryRes } from 'shared/types/general.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchAreaHistory = () => {
	const axiosPrivate = useAxiosPrivate()
	const params = useParams()
	const { auth } = useContext(AuthContext)

	const { data: boothHistory, isPending: isAreaHistoryLoading } = useQuery<HistoryRes>({
		queryKey: queryKeys.booths.history(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.areaHistory(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		boothHistory,
		isAreaHistoryLoading
	}
}
